import React, { useState, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { toast } from 'react-toastify';
import { dateRules } from './assets';
import { Alert } from 'reactstrap';
import { CardCabecalho } from './styled';
import ScoreboardService from './service';
import SimpleHeader from 'components/Headers/SimpleHeader.js';
import Loader from 'react-loader-spinner';
import DatePicker from '../../../../components/Inputs/DatePicker.js';
import { useSelector } from 'react-redux';
import {
  Container,
  Row,
  Card,
  Form,
  Col,
  CardHeader,
  Button,
  CardBody
} from 'reactstrap';

import { format } from 'date-fns';

import { buttonStyle } from 'components/Containers/ConfigurationContainer/components/utils';
import CardItem from './components/CardItem';
import { Line } from 'react-chartjs-2';
import Service from '../../../../views/ChatConfiguration/service';
import FlexSelect from 'components/Inputs/FlexSelect';

const config = {
  type: 'line',
  options: {
    scales: {
      xAxis: {
        type: 'time'
      }
    }
  }
};

const defaultAlertMessage = {
  active: false,
  message: ''
};

const ConversationReport = () => {
  const { control, handleSubmit, errors, setValue, reset, getValues } =
    useForm();
  const systemConfiguration = useSelector((state) => state.systemConfiguration);
  const showAllConversations = localStorage.getItem('show_all_conversations');
  const login = localStorage.getItem('login');

  const [isLoadingDashboard, setIsLoadingDashboard] = useState(false);
  const [dashboard, setDashboard] = useState();
  const [dataChart, setDataChart] = useState({});
  const [channels, setChannels] = useState([]);
  const [valorEmDolar, setValorEmDolar] = useState(0);
  const [valorEmReal, setValorEmReal] = useState(0);
  const [messageAlert, setShowAlert] = useState(defaultAlertMessage);

  const normId = (v) => (v == null ? '' : String(v));

  const mergeChannels = (existing, extra) => {
    const map = new Map(
      existing.map((c) => [normId(c.id), { ...c, id: normId(c.id) }])
    );
    for (const c of extra) {
      const id = normId(c.id);
      if (!map.has(id)) map.set(id, { ...c, id });
    }
    return Array.from(map.values());
  };

  async function loadDashboard(data) {
    setIsLoadingDashboard(true);

    function formatLabels(labels) {
      return labels.map((day) => format(new Date(day), 'dd/MM'));
    }

    await ScoreboardService.getScoreboard({
      dataFinal: data.dataFinal,
      dataInicial: data.dataInicial,
      idChannel: data.idChannel,
      loginAtendente: localStorage.getItem('login') || 'adm'
    })
      .then((res) => {
        const conversas = res.data.conversas || [];
        const conversasByChannel = {};
        conversas.forEach((conversa) => {
          const id = normId(conversa.idCanal ?? conversa.id_canal);
          if (!id) return;
          conversasByChannel[id] = (conversasByChannel[id] || 0) + 1;
        });

        const dynamicChannelOptions = Object.keys(conversasByChannel).map(
          (id) => {
            const amostra = conversas.find(
              (c) => normId(c.idCanal ?? c.id_canal) === id
            );
            const nome = amostra?.apelidoCanal || amostra?.whatsappOrigem || id;
            return {
              id,
              nome_canal: nome,
              custoPorConversa: 0,
              cotacaoDolar: 0
            };
          }
        );

        const effectiveChannels = mergeChannels(
          channels,
          dynamicChannelOptions
        );
        setChannels(effectiveChannels);

        const valuesByChannel = {};
        effectiveChannels.forEach((channel) => {
          const key = normId(channel.id);
          if (conversasByChannel[key]) {
            valuesByChannel[key] =
              conversasByChannel[key] * (Number(channel.custoPorConversa) || 0);
          }
        });

        let somaValorEmDolar = 0;
        let somaValorEmReal = 0;
        effectiveChannels.forEach((channel) => {
          const key = normId(channel.id);
          const usd = valuesByChannel[key] || 0;
          const cotacao = Number(channel?.cotacaoDolar) || 0;
          somaValorEmDolar += usd;
          somaValorEmReal += usd * cotacao;
        });

        setValorEmDolar(somaValorEmDolar);
        setValorEmReal(somaValorEmReal);
        //Calcular por cada canal
        const dataDay = [];
        const dataLabel = [];
        (res.data.conversasPorDia || []).forEach((conversaStr) => {
          dataLabel.push(conversaStr.slice(0, 11));
          dataDay.push(conversaStr.slice(12).split(' '));
        });

        const arr1 = [],
          arr2 = [],
          arr3 = [];
        const formatedLabels = formatLabels(dataLabel);
        dataDay.forEach((d) => {
          arr1.push(d[0]);
          arr2.push(d[1]);
          arr3.push(d[2]);
        });

        setDataChart({
          mainBoard: {
            quantidadeDeConversas: res.data.quantidadeDeConversas,
            quantidadeDeMensagens: res.data.quantidadeMensagens,
            mediaMensagensPorConversa: res.data.mediaMsgPorConversa,
            maximoConversas: res.data.maxConversasDia.numConversas,
            data:
              res.data.maxConversasDia.data?.length > 0
                ? format(new Date(res.data.maxConversasDia.data), 'dd/MM/yyyy')
                : '',
            compreensaoFraca: res.data.msgsScoreBaixo
          },
          totalMensagens: {
            labels: formatedLabels,
            datasets: [
              {
                label: 'Mensagens',
                data: arr2,
                fill: false,
                backgroundColor: ['rgb(54, 162, 235)'],
                tension: 0
              }
            ]
          },
          mediaMensagensPorConversa: {
            labels: formatedLabels,
            datasets: [
              {
                label: 'Mensagens',
                data: arr3,
                fill: false,
                backgroundColor: ['rgb(54, 162, 235)'],
                tension: 0
              }
            ]
          },
          totalConversas: {
            labels: formatedLabels,
            datasets: [
              {
                label: 'Conversas',
                data: arr1,
                fill: false,
                backgroundColor: ['rgb(54, 162, 235)'],
                tension: 0
              }
            ]
          }
        });

        setIsLoadingDashboard(false);
        setDashboard(true);
      })
      .catch((err) => {
        setIsLoadingDashboard(false);
        console.log(err);
      });
  }
  useEffect(() => {
    Service.getAll()
      .then(async (response) => {
        const channels = response.data?.channels?.whatsapp || [];

        const apiChannels = channels.map((ch) => ({
          ...ch,
          id: normId(ch.id)
        }));

        const semCotacao = apiChannels.every((i) => !i.cotacaoDolar);
        const semCustoPorConversa = apiChannels.every(
          (i) => !i.custoPorConversa
        );

        setChannels(apiChannels.filter((c) => c.ativado));

        try {
          const today = new Date();
          const start = new Date(today);
          start.setMonth(start.getMonth() - 12);
          const toISO = (d) => d.toISOString().slice(0, 10);

          const bootstrap = await ScoreboardService.getScoreboard({
            dataInicial: toISO(start),
            dataFinal: toISO(today),
            idChannel: ''
          });

          const conversas = bootstrap?.data?.conversas || [];
          const byId = new Map();
          conversas.forEach((c) => {
            const id = normId(c.idCanal ?? c.id_canal);
            if (!id) return;
            if (!byId.has(id)) {
              byId.set(id, {
                id,
                nome_canal: c.apelidoCanal || c.whatsappOrigem || id,
                custoPorConversa: 0,
                cotacaoDolar: 0
              });
            }
          });

          const discovered = Array.from(byId.values());
          setChannels((prev) => mergeChannels(prev, discovered));
        } catch (e) {
          console.log('Requisição de canais via conversas falhou', e);
        }

        if (semCotacao || semCustoPorConversa) {
          setShowAlert({
            active: true,
            message:
              'Para visualizar os dados monetários do chatbot, é necessário configurar a cotação do dólar e o custo por conversa.'
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          toast.error('Erro ao carregar as respostas do bot!', {
            autoClose: 3000,
            closeOnClick: true
          });
        }
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggleAlert = () => {
    setShowAlert({ active: false, message: '' });
  };

  const clearData = () => {
    setDashboard('');
  };

  const toISOFormat = (dateTimeString, bar = false) => {
    const [date] = dateTimeString.split(' ');
    const [DD, MM, YYYY] = date.split('/');

    if (bar) return `${MM}/${DD}/${YYYY}`;
    return `${YYYY}-${MM}-${DD}`;
  };

  const getDataDTO = (data) => {
    let formatedData;

    formatedData = {
      ...data,
      dataInicial: `${toISOFormat(data.dataInicial)}`,
      dataFinal: `${toISOFormat(data.dataFinal)}`,
      idChannel: data.channel
    };
    return formatedData;
  };

  const onSubmit = (data) => {
    clearData();
    try {
      const formatedData = getDataDTO(data);

      loadDashboard(formatedData);
    } catch (err) {
      console.log(err);
      toast.error(err || 'Ops, ocorreu um erro!', {
        autoClose: 3000,
        closeOnClick: true
      });
    }
  };

  const cleanFilter = () => {
    reset({
      dataInicial: new Date().toLocaleDateString('pt-br'),
      dataFinal: new Date().toLocaleDateString('pt-br'),
      fila: '',
      encerradaPor: '',
      group: '',
      atendente: showAllConversations === 'true' ? '' : login,
      nome: '',
      situacao: '',
      atendimentoBot: '',
      status: '',
      sucessoAtendimento: '',
      isMobile: '',
      satisfacao: '',
      canal: '',
      conteudoDaMensagem: ''
    });
  };

  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );

  return (
    <>
      <SimpleHeader
        name="Form validation"
        parentName="Forms"
        showBackArrow="not"
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3>Dados do Chatbot - Whatsapp</h3>
                </CardHeader>
                <CardBody>
                  <>
                    <Form
                      className="needs-validation"
                      onSubmit={handleSubmit(onSubmit)}
                    >
                      <Row className="mb-3"></Row>

                      <Row className="mb-3">
                        <Col md="4">
                          <label className="form-control-label">
                            Data inicial*
                          </label>
                          <Controller
                            render={(props) => (
                              <DatePicker
                                fieldName="dataInicial"
                                valueController={setValue}
                                defaultValue={props.value}
                              />
                            )}
                            control={control}
                            name="dataInicial"
                            rules={dateRules}
                            defaultValue={new Date().toLocaleDateString(
                              'pt-br'
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="dataInicial"
                            render={({ message }) => errorFormMessage(message)}
                          />
                        </Col>
                        <Col md="4">
                          <label className="form-control-label">
                            Data final*
                          </label>
                          <Controller
                            render={(props) => (
                              <DatePicker
                                fieldName="dataFinal"
                                valueController={setValue}
                                defaultValue={props.value}
                              />
                            )}
                            control={control}
                            name="dataFinal"
                            defaultValue={new Date().toLocaleDateString(
                              'pt-br'
                            )}
                            rules={{
                              ...dateRules,
                              validate: (value) => {
                                if (
                                  new Date(toISOFormat(value, true)) <
                                  new Date(
                                    toISOFormat(
                                      getValues()['dataInicial'],
                                      true
                                    )
                                  )
                                ) {
                                  return 'A data final não pode ser anterior à inicial!';
                                } else {
                                  return true;
                                }
                              }
                            }}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="dataFinal"
                            render={({ message }) => errorFormMessage(message)}
                          />
                        </Col>
                        <Col md="4">
                          <label className="form-control-label">Canal</label>
                          <Controller
                            render={(props) => (
                              <FlexSelect
                                isClearable={true}
                                dataOptions={channels}
                                isMulti={false}
                                closeMenuOnSelect={false}
                                value={props.value}
                                valueController={setValue}
                                fieldName="channel"
                                labelName="nome_canal"
                                valueName="id"
                                minHeight="1rem"
                              />
                            )}
                            control={control}
                            name="channel"
                            defaultValue=""
                          />
                          <ErrorMessage
                            errors={errors}
                            name="channel"
                            render={({ message }) => errorFormMessage(message)}
                          />
                        </Col>
                      </Row>
                      <Button
                        style={buttonStyle(systemConfiguration.primary_color)}
                        type="submit"
                        disabled={isLoadingDashboard}
                      >
                        Buscar
                      </Button>
                      <Button
                        onClick={cleanFilter}
                        style={buttonStyle(
                          systemConfiguration.cancelation_button_color
                        )}
                      >
                        Limpar
                      </Button>
                    </Form>
                    {isLoadingDashboard ? (
                      <Row className="justify-content-md-center">
                        <Loader
                          type="TailSpin"
                          color={systemConfiguration.primary_color}
                          height={100}
                          width={100}
                        />
                      </Row>
                    ) : (
                      dashboard && (
                        <>
                          <Row>
                            <Col md="12">
                              <Alert
                                color="info"
                                isOpen={messageAlert.active}
                                toggle={toggleAlert}
                              >
                                {messageAlert.message}
                              </Alert>
                            </Col>
                          </Row>

                          <Row>
                            <Col md="6" xl="4">
                              <CardItem
                                title="Total de conversas"
                                text={dataChart.mainBoard.quantidadeDeConversas}
                                subText={`
                                  US$
                                    ${valorEmDolar.toFixed(2)}
                                     - R$
                                    ${valorEmReal.toFixed(2)} `}
                                tooltip="O número total de conversas entre usuários ativos e seu aplicativo, somado as conversas de campanhas, durante o período selecionado."
                                icon="fa fa-info-circle"
                              />
                            </Col>
                            <Col md="6" xl="4">
                              <CardItem
                                title="Média de msg por conversa"
                                text={
                                  dataChart.mainBoard.mediaMensagensPorConversa
                                }
                                tooltip="A média de mensagens por conversa é o total de mensagens recebidas durante o intervalo de datas selecionado dividido pelo total de conversas durante o intervalo de datas selecionado."
                                icon="fa fa-info-circle"
                              />
                            </Col>
                            <Col md="6" xl="4">
                              <CardItem
                                title="Máximo de conversas"
                                text={dataChart.mainBoard.maximoConversas}
                                subText={dataChart.mainBoard.data}
                                tooltip="Máx. de conversas é o número máximo de conversas que ocorreram durante um único intervalo de tempo dentro do intervalo de datas selecionado."
                                icon="fa fa-info-circle"
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col md="12" xl="12">
                              <Card>
                                <CardHeader>
                                  <CardCabecalho>
                                    <div>
                                      <h5 className="h3 mb-0">
                                        Total de conversas
                                      </h5>
                                      <h6 className="surtitle">POR: Dia</h6>
                                    </div>
                                    <h5 className="h3 mb-0">
                                      Total:{' '}
                                      {
                                        dataChart.mainBoard
                                          .quantidadeDeConversas
                                      }
                                    </h5>
                                  </CardCabecalho>
                                </CardHeader>
                                <CardBody>
                                  <div className="chart">
                                    <Line
                                      data={dataChart.totalConversas}
                                      options={config}
                                      className="chart-canvas"
                                      id="chart-bars"
                                    />
                                  </div>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                          <Row>
                            <Col md="6" xl="6">
                              <Card>
                                <CardHeader>
                                  <CardCabecalho>
                                    <div>
                                      <h5 className="h3 mb-0">
                                        Média mensagem por conversa
                                      </h5>
                                      <h6 className="surtitle">POR: Dia</h6>
                                    </div>
                                    <h5 className="h3 mb-0">
                                      Média:{' '}
                                      {
                                        dataChart.mainBoard
                                          .mediaMensagensPorConversa
                                      }
                                    </h5>
                                  </CardCabecalho>
                                </CardHeader>
                                <CardBody>
                                  <div className="chart">
                                    <Line
                                      data={dataChart.mediaMensagensPorConversa}
                                      options={config}
                                      className="chart-canvas"
                                      id="chart-bars"
                                    />
                                  </div>
                                </CardBody>
                              </Card>
                            </Col>
                            <Col md="6" xl="6">
                              <Card>
                                <CardHeader>
                                  <CardCabecalho>
                                    <div>
                                      <h5 className="h3 mb-0">
                                        Total de mensagens
                                      </h5>
                                      <h6 className="surtitle">POR: Dia</h6>
                                    </div>
                                    <h5 className="h3 mb-0">
                                      Total:{' '}
                                      {
                                        dataChart.mainBoard
                                          .quantidadeDeMensagens
                                      }
                                    </h5>
                                  </CardCabecalho>
                                </CardHeader>

                                <CardBody>
                                  <div className="chart">
                                    <Line
                                      data={dataChart.totalMensagens}
                                      options={config}
                                      className="chart-canvas"
                                      id="chart-bars"
                                    />
                                  </div>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        </>
                      )
                    )}
                  </>
                </CardBody>
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default ConversationReport;
